import getObject from './getObject'
import updateGroup from './updateGroup'

// const createGroup = async (group, id) => createDoc(getCollection, getObject(group))
const createGroup = async (group, id) => updateGroup(id, getObject(group))

export default createGroup
